export default "__VITE_ASSET__C94tt$Sh__"